import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as moment from 'moment';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventas-por-zonas',
  templateUrl: './print-ventas-por-zonas.component.html',
  styleUrls: ['./print-ventas-por-zonas.component.css']
})
export class PrintVentasPorZonasComponent implements OnInit {

  constructor(
    private reportViewer: ReportViewerService,
    private data: DataService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) { }
  mes: string = '1';
  idvende: string = '1';
  ubigeo: string = '1';
  public detfactus: any[] = [];
  public sumacantidad: number = 0;
  public sumadiferencia: number = 0;
  public sumaprestamo: number = 0;
  public sumapreuni: number = 0;
  public sumatotal: number = 0;
  public pagventas: any = 0;
  public rangofechas: RangoFechas = new RangoFechas();
  public zona: any;
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public filtro: Filtro = new Filtro()
  public sucursal: number;
  @ViewChild('pagina', null) public pagina: ElementRef;
  async ngOnInit() {
  }

  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }


  onMonthSelect() {
    if (this.mes) {
      // Obtener el año actual
      const year = moment().year();

      // Obtener la fecha de inicio y fin del mes seleccionado usando Moment.js
      this.fecinicio = moment(`${year}-${this.mes}-01`).startOf('month').format('YYYY-MM-DD');
      this.fecfin = moment(`${year}-${this.mes}-01`).endOf('month').format('YYYY-MM-DD');
      this.GetZona()
    }
  }

  GetZona() {
    this.data.GetFromId(this.data.api.ubicacion, this.ubigeo).subscribe((res) => {
      console.log("Zona obtenido", res);
      this.zona = res;
    }, (error) => { })
  }

  GetData() {
    this.filtro.idvende = this.idvende
    this.filtro.mes = this.mes
    this.filtro.ubigeo = this.ubigeo
    this.filtro.idsucursal = this.data.getSucursalId()
    this.data.Post('ventasclientes_zonas', this.filtro).subscribe(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
        this.detfactus = []
      } else {
        this.detfactus = r;
        this.GetTotalVentas()
        this.cdr.detectChanges();
        setTimeout(() => {
          // Generar el PDF
          const blob = this.printerVentas();
          // Mostrar en el modal reutilizable
          if (blob) {
            const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
            this.reportViewer.mostrarPDF(
              blob,
              'Reporte de Ventas a Clientes por Zona',
              `reporte_ventas_clientes_zona${fecha}.pdf`
            );
          }
        })
      }
    }, (e) => { console.log(e) })
  }

  GetTotalVentas() {
    this.detfactus.forEach(detalle => {
      this.sumacantidad += +detalle.total_cantidad
      this.sumadiferencia += +detalle.diferencia
      this.sumaprestamo += +detalle.tot_presdevo
    });

  }

  public isbutton: Boolean = true;
  click: boolean = false;

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  printerVentas():Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'VENTAS A CLIENTES POR ZONA', x: 67, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Zona: ${this.zona.descripcion}`, 10, 28);
      doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 33);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 33);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['Cliente', 'Documento', 'Direccion', 'Telefono', 'Cantidad'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#ventasporzonas tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        9: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 8,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(10);
        doc.text('Cliente', data.settings.margin.left, data.cursor.y);
        doc.text('Documento', data.settings.margin.left, data.cursor.y);
        doc.text('Direccion', data.settings.margin.left, data.cursor.y);
        doc.text('Telefono', data.settings.margin.left, data.cursor.y);
        doc.text('Cantidad', data.settings.margin.left, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    //doc.save('informe.pdf');

  }

  mouseenter() {
    if (!this.click) {
      this.isbutton = true;
    } else {
      this.isbutton = false;
    }
  }

  back() {
    //this.router.navigateByUrl("/");
    window.history.back();
  }

}
